// extracted by mini-css-extract-plugin
export default {"chatting_area_wrap":"chatArea_chatting_area_wrap__Ku-yl"};